export const apiUrl = `${process.env.REACT_APP_API_HOST}/api/`;
export const RestURL = `${process.env.REACT_APP_API_HOST}/`;
export const tomcatHost = `${process.env.REACT_APP_TOMCAT_HOST}`;
export const tomcatHostUpload = `${process.env.REACT_APP_TOMCAT_HOST_UPLOAD}`;
export const herokuProxyHost = `${process.env.REACT_APP_HEROKU_PROXY_HOST}`;
export const s3SupportDocs = `${process.env.REACT_APP_S3_SUPPORT_DOCS}`
// Pagination
export const DEFAULT_PAGINATION_SIZE = 20;

// Dates
export const DEFAULT_UI_DATE_FORMAT = 'MM-dd-yy';
export const DEFAULT_DB_DATE_FORMAT = 'yyyy-MM-dd';


console.log(process.env.REACT_APP_S3_SUPPORT_DOCS, "stagging")


// WEBPACK FOOTER //
// ./src/config/properties.js